import { IPricingItemSupplierResource } from "@/views/case/parts/TheTourPricing.vue";
import TourDayItemResource from "@/api/objects/TourDayItemResource";

export const calculateAllNetValidated = (data: IPricingItemSupplierResource[] | TourDayItemResource[]): 'mixed' | boolean => {
  const allNetValidated = data.every(
    (item: IPricingItemSupplierResource | TourDayItemResource) => item.netValidated);
  const someNetValidated = data.some((item) => item.netValidated);

  return allNetValidated ? true : someNetValidated ? 'mixed' : false;
};


export const calculateAllPaymentStatus = (data: IPricingItemSupplierResource[] | TourDayItemResource[], status: string): 'mixed' | boolean => {
  const allPaymentStatus = data.every(
    (item: IPricingItemSupplierResource | TourDayItemResource) => item.paymentStatus === status);
  const somePaymentStatus = data.some((item) => item.paymentStatus === status);

  return allPaymentStatus ? true : somePaymentStatus ? 'mixed' : false;
};

// Calculate amount paid and amount pending of group
export const calculatePriceGroup = (data: IPricingItemSupplierResource[] | TourDayItemResource[]): {
  netPrice: number,
  grossPrice: number,
  amountPaid: number,
  amountPending: number
} => {
  // Calculate net price of group
  let netPrice = data.reduce(
    (sum: number, item: any) => {
      const isUpdated = !!(item.isUpdatedBySupplier || item.is_updated_by_supplier);
      const supplierPrice = item.supplierPrice || item.supplier_price || 0;
      const net = item.netPrice || item.net_price || 0;
      const quantity = Number(item.quantity || 1);
      const price = isUpdated ? supplierPrice : net;
      return sum + (Number(price) * quantity);
    }, 0);

  if (netPrice % 1 !== 0) {
    netPrice = Number(netPrice.toFixed(2));
  }

  // Calculate gross price of group
  let grossPrice = data.reduce(
    (sum: number, item: any) => {
      const isUpdated = !!(item.isUpdatedBySupplier || item.is_updated_by_supplier);
      const quantity = Number(item.quantity || 1);
      if (isUpdated) {
        const net = Number(item.supplierPrice || item.supplier_price) || 0;
        const markup = Number(item.markup) || 0;
        const gross = net * (1 + markup / 100);
        return sum + (gross * quantity);
      }
      return sum + (Number(item.grossPrice || item.gross_price || 0) * quantity);
    }, 0);

  if (grossPrice % 1 !== 0) {
    grossPrice = Number(grossPrice.toFixed(2));
  }

  let amountPaid = data.reduce(
    (sum: number, item: TourDayItemResource | IPricingItemSupplierResource) => sum + (Number(item.amountPaid) || 0), 0);

  if (amountPaid % 1 !== 0) {
    amountPaid = Number(amountPaid.toFixed(2));
  }

  const amountPending = netPrice - amountPaid;

  return {
    netPrice,
    grossPrice,
    amountPaid,
    amountPending,
  }
};
